<!-- Notifications de spectateurs -->
<div class="viewer-notifications" *ngIf="viewerNotifications.length > 0">
  <div class="notification" *ngFor="let notification of viewerNotifications">
    <div class="notification-content">
      <i class="fas fa-user-plus"></i>
      <span>{{ notification.name }} a rejoint le stream</span>
    </div>
  </div>
</div>

<div class="broadcaster-container">
  <div class="stream-content">
    <button class="end-btn top-end-btn" (click)="showEndStreamConfirmation()">
      <i class="fas fa-stop-circle"></i>
      <span class="btn-text">Terminer le live</span>
    </button>
    <div class="video-container">
      <div #localVideo id="local-video" class="local-video"></div>
      <div class="stream-controls">
        <button class="control-btn" (click)="toggleChat()" [class.active]="isChatEnabled">
          <i class="fas" [ngClass]="isChatEnabled ? 'fa-comment' : 'fa-comment-slash'"></i>
        </button>
        <button class="control-btn" (click)="toggleMute()" [class.active]="!isMuted">
          <i class="fas" [ngClass]="isMuted ? 'fa-microphone-slash' : 'fa-microphone'"></i>
        </button>
        <button class="control-btn" (click)="toggleVideo()" [class.active]="!isVideoOff">
          <i class="fas" [ngClass]="isVideoOff ? 'fa-video-slash' : 'fa-video'"></i>
        </button>
        <button class="control-btn" (click)="toggleScreenShare()" [class.active]="isScreenSharing">
          <i class="fas fa-desktop"></i>
        </button>
        <button class="control-btn" (click)="toggleCamera()" [class.active]="!isCameraOff">
          <i class="fas" [ngClass]="isCameraOff ? 'fa-camera-slash' : 'fa-camera'"></i>
        </button>
        <button class="control-btn" (click)="openShareModal()">
          <i class="fas fa-share-alt"></i>
        </button>
        <!-- <button class="control-btn" (click)="toggleBeauty()" [class.active]="isBeautyEnabled">
                <i class="fas fa-magic"></i>
              </button>
              <button class="control-btn" (click)="toggleSettings()" [class.active]="showSettings">
                <i class="fas fa-cog"></i>
              </button> -->
      </div>
    </div>

    <div class="stream-info" *ngIf="stream">
      <div class="stream-header">
        <h2>{{ stream.title }}</h2>
        <div class="stream-meta">
          <span class="viewer-count">
            <i class="fas fa-eye"></i>
            {{ viewerCount }} spectateurs
          </span>
          <span class="stream-date" *ngIf="liveElapsedDisplay">
            <i class="far fa-clock"></i>
            {{ liveElapsedDisplay }}
          </span>
          <span class="stream-date" *ngIf="!liveElapsedDisplay">
            <i class="far fa-clock"></i>
            {{ stream.created_at | date:'short' }}
          </span>
        </div>
      </div>
      <p class="stream-description">{{ stream.description }}</p>
    </div>
  </div>

  <div class="right-column">
    <div class="viewers-panel" *ngIf="viewers.length > 0">
      <div class="viewers-header">
        <h3>Spectateurs ({{ viewerCount }})</h3>
      </div>
      <div class="viewers-list">
        <div *ngFor="let viewer of viewers" class="viewer-item">
          <img [src]="viewer.profile_picture || 'assets/images/avatar.jpeg'" [alt]="viewer.name"
            class="viewer-avatar">
          <span class="viewer-name">{{ viewer.name }}</span>
        </div>
      </div>
    </div>

    <app-chat *ngIf="isChatEnabled" [streamId]="slug" [viewerCount]="viewerCount" [currentUserId]="currentUserId">
    </app-chat>

    <!-- Message quand le chat est désactivé -->
    <div *ngIf="!isChatEnabled" class="chat-disabled-message">
      <i class="fas fa-comment-slash"></i>
      <p>Le chat est désactivé</p>
    </div>
  </div>
</div>

<app-confirm-modal [isOpen]="showEndStreamModal" title="Terminer le live"
  message="Êtes-vous sûr de vouloir terminer ce live ? Cette action est irréversible." confirmText="Terminer le live"
  cancelText="Annuler" (confirm)="endStream()" (close)="showEndStreamModal = false">
  <div class="loader-container" *ngIf="isLoading">
    <div class="loader"></div>
    <span>Traitement en cours...</span>
  </div>
</app-confirm-modal>

<!-- Modal de partage -->
<app-share-modal [isOpen]="showShareModal" [shareUrl]="shareUrl" [title]="shareTitle"
  (closeModal)="closeShareModal()"></app-share-modal>

<!-- Ajouter des notifications pour les nouveaux spectateurs -->
<div class="viewer-notifications">
  <div *ngFor="let notification of viewerNotifications" class="viewer-notification" [@fadeInOut]>
    <i class="fas fa-user-plus"></i>
    <span>{{ notification.name }} a rejoint le stream</span>
  </div>
</div>

<!-- Ajouter les styles pour les animations -->
<style>
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }

    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

  .viewer-notification {
    animation: fadeIn 0.3s ease-out, fadeOut 0.3s ease-in 4.7s;
    animation-fill-mode: forwards;
  }

  .broadcaster-container {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 20px;
    height: 100vh;
    padding: 20px;
  }

  .stream-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: relative;
  }

  .top-end-btn {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000;
    background-color: rgba(255, 0, 0, 0.8);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.3s ease;
  }

  .top-end-btn:hover {
    background-color: rgba(255, 0, 0, 1);
  }

  .top-end-btn i {
    font-size: 1.2em;
  }

  .viewers-panel {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    width: 100%;
    max-height: 200px;
  }

  .viewers-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .viewers-header h3 {
    color: white;
    margin: 0;
    font-size: 16px;
  }

  .viewers-list {
    max-height: 150px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .viewer-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  .viewer-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
  }

  .viewer-name {
    color: white;
    font-size: 14px;
  }

  app-chat {
    height: calc(100vh - 300px);
    overflow-y: auto;
  }

  .stream-controls {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    background: rgba(0, 0, 0, 0.7);
    padding: 10px;
    border-radius: 8px;
  }

  .control-btn {
    background: none;
    border: none;
    color: white;
    font-size: 1.2em;
    padding: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .control-btn:hover {
    transform: scale(1.1);
  }

  .control-btn.active {
    color: #fff;
  }

  .video-container {
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    background: #000;
    border-radius: 8px;
    overflow: hidden;
  }

  .local-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .stream-info {
    background: rgba(0, 0, 0, 0.7);
    padding: 15px;
    border-radius: 8px;
    color: white;
  }

  .stream-header h2 {
    margin: 0 0 10px 0;
    font-size: 1.5em;
  }

  .stream-meta {
    display: flex;
    gap: 15px;
    font-size: 0.9em;
    color: #ccc;
  }

  .stream-description {
    margin: 10px 0 0 0;
    font-size: 0.9em;
    color: #ccc;
  }

  /* Media Queries */
  @media (max-width: 1200px) {
    .broadcaster-container {
      grid-template-columns: 1fr 250px;
      gap: 15px;
      padding: 15px;
    }
  }

  @media (max-width: 992px) {
    .broadcaster-container {
      grid-template-columns: 1fr;
      height: auto;
    }

    .right-column {
      order: -1;
      margin-bottom: 20px;
    }

    .viewers-panel {
      max-height: 150px;
    }

    app-chat {
      height: 300px;
    }
  }

  @media (max-width: 768px) {
    .broadcaster-container {
      padding: 10px;
    }

    .stream-controls {
      bottom: 10px;
      gap: 5px;
    }

    .control-btn {
      font-size: 1em;
      padding: 6px;
    }

    .stream-header h2 {
      font-size: 1.2em;
    }

    .stream-meta {
      flex-direction: column;
      gap: 5px;
    }

    .top-end-btn {
      padding: 6px 12px;
    }

    .btn-text {
      display: none;
    }

    .video-container {
      height: 400px !important;
    }
  }

  @media (max-width: 576px) {
    .broadcaster-container {
      display: flex;
      flex-direction: column;
      height: auto;
      min-height: 100vh;
    }

    .stream-content {
      order: 1;
    }

    .right-column {
      order: 2;
      margin-top: 20px;
    }

    .stream-controls {
      width: 90%;
      justify-content: space-around;
    }

    .viewers-panel {
      max-height: 120px;
    }

    .viewer-item {
      padding: 6px;
    }

    /* Style pour le bouton de contrôle du chat */
    .control-btn.active {
      background-color: #4CAF50;
      color: white;
    }

    .control-btn:not(.active) {
      background-color: #f44336;
      color: white;
    }

    /* Message quand le chat est désactivé */
    .chat-disabled-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 2rem;
      text-align: center;
      background-color: #f8f9fa;
      border-radius: 8px;
      margin: 1rem;
    }

    .chat-disabled-message i {
      font-size: 3rem;
      color: #6c757d;
      margin-bottom: 1rem;
    }

    .chat-disabled-message p {
      color: #6c757d;
      margin: 0;
      font-size: 0.9rem;
    }

    .viewer-avatar {
      width: 25px;
      height: 25px;
    }

    .viewer-name {
      font-size: 12px;
    }

    app-chat {
      height: 250px;
      margin-top: 10px;
    }

    .video-container {
      aspect-ratio: 16/9;
      height: 400px !important;
    }
  }
</style>